import { SORT_ORDER } from 'constants.js'
import { combineReducers } from 'redux'

import { SET_SORT, SORT_COLUMNS } from './constants'

const { ASC, DESC } = SORT_ORDER

const initialSortState = {
  sortBy: SORT_COLUMNS.SHARE_CLUB_CARD,
  order: DESC,
}
const sort = (state = initialSortState, { payload, type }) => {
  switch (type) {
    case SET_SORT:
      if (payload === state.sortBy) {
        return {
          order: state.order === DESC ? ASC : DESC,
          sortBy: payload,
        }
      }

      return {
        order: DESC,
        sortBy: payload,
      }

    default:
      return state
  }
}

export default combineReducers({
  sort,
})
